// Public paths (accessible without being logged in except for auth routes)
export const ROOT_PATH = '/' as const;
export const PUBLIC_PATHS = [
  // Check root path separately as all routes will match it due to the /
  '/community-guidelines',
  '/community',
  '/about-us',
  '/how-it-works',
  '/faq',
  '/trust',
  '/help',
  '/privacy',
  '/terms',
  '/careers',
  '/contact',
  '/post',
  '/browse-skills',
  '/join',
  '/why-choose-us',
] as const;

// Auth routes (accessible without being logged in)
export const AUTH_PATHS = [
  '/auth/login',
  '/auth/signup',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/create-new-password',
  '/auth/google-callback',
  '/auth/refresh',
] as const;

export const UNAUTHENTICATED_REDIRECT = '/auth/login' as const;
export const AUTHENTICATED_REDIRECT = '/feed' as const;
